/* eslint-disable no-useless-computed-key */
import { Box, Button, Flex, Heading, VStack } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { BsLightningCharge } from "react-icons/bs";
import { FaPhone } from "react-icons/fa6";
import { TbMessageChatbot } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { fetchController } from "../../utils/FetchController/fetchController";
import Loader from "../../utils/Loader/Loader";
import PaginationSizeSelect from "../../utils/Loader/PaginationSizeSelect";
import Paginator from "../../utils/Loader/Paginator";
import { getHostDomain, getTagsData } from "../../utils/utils";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import Table from "../Tables/Table";
import AssistantTour from "./AssistantsTour";
import TagsColumn from "../Tags/TagsColumn";
import Layout from "../Layout/Layout";

const Assistants = () => {
  const baseUrl = getHostDomain();
  const navigate = useNavigate();
  const agency = useContext(AgencyContext);
  const { textColor, buttonColorScheme } = agency;
  const [status, setStatus] = useState("idle");
  const [tableData, setTableData] = useState([]);
  const [heads, setHeads] = useState([]);

  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [paginationSize, setPaginationSize] = useState(10);

  const endpoint = `/api/v1/assistant/get_my_details?size=${paginationSize}&page=${page}`;
  const urlHit = baseUrl + endpoint;

  const hitFetch = async () => {
    try {
      setStatus("loading");
      const getData = await fetchController(urlHit, "GET");
      setPages(getData?.data?.pages);

      if (getData?.data) {
        const updatedData = getData.data.items.map((item) => {
          const tagsData = getTagsData(item?.tags);

          return {
            assistant_type: item.assistant_type,
            type:
              item.assistant_type === "phone" ? (
                <FaPhone />
              ) : item.assistant_type === "realtime_openai" ? (
                <BsLightningCharge />
              ) : (
                <TbMessageChatbot />
              ),
            name: item.name,
            description: item.description,
            ["data_Sources"]: (
              <Box ml={12}>{item.data_sources_count.toLocaleString()}</Box>
            ),
            ["total_word_count"]: (
              <Box ml={12}>{item.total_word_count.toLocaleString()}</Box>
            ),
            ["intents_count"]: <Box ml={12}>{item.intents_count}</Box>,
            id: item.id,
            webhook_id: item.webhook_id,
            Tags: <TagsColumn tagsData={tagsData} refreshTable={hitFetch} />,
          };
        });
        const headsData = [
          "type",
          "name",
          "description",
          "data_Sources",
          "total_word_count",
          "intents_count",
          "Tags",
        ];
        const columns = headsData.map((key) => ({
          Header: key,
          accessor: key,
          Filter: ({ column }) => <input {...column.filterProps} />,
        }));

        setTableData(updatedData);
        setHeads(columns);
      }
      setStatus("success");
    } catch (error) {
      setStatus("failure");
    }
  };

  useEffect(() => {
    hitFetch();
  }, [page, paginationSize]);

  const [assistantTourVisibility, setAssistantTourVisibility] = useState(
    localStorage.getItem("assistantTourVisibility") ? false : true
  );
  const onCloseAssistantTour = () => {
    localStorage.setItem("assistantTourVisibility", false);
    setAssistantTourVisibility(false);
  };

  return (
      <VStack
        h={"100%"}
        spacing={2}
        justifyContent={"space-between"}
        borderRadius="md"
      >
        <Flex direction={"column"} gap={3} h={"95%"} w={"100%"}>
          <Flex gap={2} w={"100%"} alignItems="center" p={2}>
            <Heading color={textColor} fontSize="xl">
              Assistants
            </Heading>
            <Button
              colorScheme={buttonColorScheme}
              onClick={() => navigate("/ai-agents/assistants/new")}
              size={"sm"}
            >
              {"Create Assistant"}
            </Button>
            {assistantTourVisibility ? (
              <AssistantTour onCloseAssistantTour={onCloseAssistantTour} />
            ) : null}
          </Flex>

          {status === "loading" ? (
            <Loader />
          ) : (
            <Table
              fetch={hitFetch}
              columns={heads}
              data={tableData}
              table="assistant"
            />
          )}
        </Flex>

        <Flex
          w={"100%"}
          justifyContent={"flex-end"}
          alignItems={"center"}
          gap={2}
        >
          <PaginationSizeSelect
            paginationSize={paginationSize}
            setPaginationSize={setPaginationSize}
            tableLength={tableData.length}
          />
          <Paginator
            colorScheme={buttonColorScheme}
            onChangePage={setPage}
            page={page}
            pages={pages}
          />
        </Flex>
      </VStack>
  );
};

export default Assistants;
